@if (context()) {
<button
  type="button"
  class="sb-text-condition-button"
  [class.sb-field__companion-btn]="iconOnly()"
  [class.sb-text-condition-button--inline]="!iconOnly()"
  [class.sb-text-condition-button--active]="insideBlock()"
  [disabled]="isDisabled"
  [attr.aria-label]="iconOnly() ? label : null"
  [title]="label"
  (mousedown)="$event.preventDefault()"
  (click)="open()">
  <svg class="sb-text-condition-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <circle cx="6" cy="5" r="2" /><circle cx="18" cy="5" r="2" /><circle cx="12" cy="19" r="2" />
    <path d="M6 7v2a3 3 0 003 3h6a3 3 0 003-3V7" /><path d="M12 12v5" />
  </svg>
  @if (!iconOnly()) {
  <span class="sb-text-condition-button__text">{{ insideBlock() ? 'Edit condition' : 'Condition' }}</span>
  }
</button>
}
